<div class="is-flex align-center">
    <div
        class="notification-container pt-16 px-20 is-flex pb-32"
        [class.custom-class]="props$$()?.styles?.backgroundColor && props$$()?.styles?.textColor"
        [class.open]="status$$()"
        [style.backgroundColor]="props$$()?.styles?.backgroundColor"
    >
        <div class="is-flex mb-8">
            <span class="mr-40 ttu title-m" [style.color]="props$$()?.styles?.textColor">{{ props$$()?.title | translate }}</span>
            <span class="notification-close">
                <md-icon name="close-s" class="ico-white" (click)="closeNotification()"></md-icon>
            </span>
        </div>

        @if (props$$()?.action && props$$()?.message) {
            <span (click)="clickAction()" class="mr-40 link-raw text-m" [style.color]="props$$()?.styles?.textColor">
                {{ props$$()?.message | translate }}
            </span>
        } @else if (props$$()?.message) {
            <span class="mr-40 text-m" [style.color]="props$$()?.styles?.textColor">{{ props$$().message | translate }}</span>
        }
    </div>
</div>
